import styled from 'styled-components'
import Image from 'common/image'
import WinIcon from 'assets/wins_icon.png'
import { useTranslation } from 'react-i18next'

const BoxContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 1164px;
    height: 429px;
    padding: 48px;
    justify-content: space-between;
    align-items: center;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const LeftSection = styled.div`
    width: 503px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 56px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
`

const TitleUnderLine = styled.div`
    width: 80px;
    height: 5px;
    background: #d9c277;
`

const FirstLineRow = styled.div`
    padding-top: 32px;
    display: flex;
    flex-direction: row;
`

const FirstLineText = styled.div`
    color: #4e3821;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const SecondLineText = styled.div`
    padding-top: 24px;
    color: #4e3821;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const RightSection = styled.div`
    width: 500px;
    height: 333px;
    aspect-ratio: 500/333;
`

export default function WhatIsWins() {
    const { t } = useTranslation('', { keyPrefix: 'earnwins.whatiswins' })

    return (
        <BoxContainer>
            <LeftSection>
                <TitleContainer>
                    <TitleText>{t('leftLabel')}</TitleText>
                    <Image
                        src={WinIcon}
                        width={30}
                        height={30}
                        alt="wins icon"
                        style={{
                            marginLeft: '6px',
                            marginRight: '2px',
                        }}
                    />
                    <TitleText>{t('rightLabel')}</TitleText>
                </TitleContainer>
                <TitleUnderLine />
                <FirstLineRow>
                    <FirstLineText>{t('firstParagraph')}</FirstLineText>
                </FirstLineRow>
                <SecondLineText>{t('secondParagraph')}</SecondLineText>
            </LeftSection>
            <RightSection>
                <Image
                    src={t('whatiswinsImage')}
                    width={500}
                    height={333}
                    style={{ borderRadius: '25px' }}
                    alt="earns wins promotion banner"
                />
            </RightSection>
        </BoxContainer>
    )
}
